import { FALLBACK_PARTNER } from './common/constants/trading.constants';

export const appConfig = {
  isLocal: process.env.REACT_APP_IS_LOCAL === 'true',
  isProd: process.env.REACT_APP_ENVIRONMENT === 'production',
  routeTracingEnabled: process.env.REACT_APP_ROUTE_TRACING_ENABLED === 'true',
  clearLSCounter: 3,
  maxIntervalForGetAccountMs: 3 * 1000,
  maxLengthOfSymbolsQueue: 5,
  minRiskMoney: 2,
  maxChartHistoryFetchesCount: 7,
  wsRetries: 13, // which results in 91 seconds to lead to error screen
  wsFailsMax: 200,
  wsSilenceTimeout: 20,
  wsConnectingTimeout: 10,
  candlesLoadingTimeout: 4 * 1000,
  lastTickChartMargin: 6, // what part of chart width last tick's margin would be
  candlesMarginX: 7,
  preloadChartScreens: 3,
  ticksOnScreenWidthPart: 22, // coefficient to calculate visible ticks count from screen width
  minDeposit: +process.env.REACT_APP_MIN_DEPOSIT || 10,
  defaultDeposit: +process.env.REACT_APP_DEFAULT_DEPOSIT || 50,
  payLimits: {
    demo: {
      deposit: process.env.REACT_APP_DEMO_DEPOSIT_MAX || Infinity,
      withdraw: process.env.REACT_APP_DEMO_WITHDRAW_MAX || Infinity,
    },
    real: {
      deposit: process.env.REACT_APP_REAL_DEPOSIT_MAX || Infinity,
      withdraw: process.env.REACT_APP_REAL_WITHDRAW_MAX || Infinity,
    },
  },
  whiteLabelPartner:
    process.env.REACT_APP_WHITELABEL_PARTNER || FALLBACK_PARTNER,
};
